import { banco } from '../db/banco'
import type { Meta } from '../db/tipos'
import { numerosDoMes, type NumerosDoMes } from './historico'
import {
  destraveDaBase, mesDe, mesesFechados, primeiroDiaDoMes, ultimoDiaDoMes,
  type Base, type EstadoDestrave,
} from './destrave'
import { lerConfiguracao } from './configuracao'
import { sugerir, type ResultadoSugestao } from './bases'

export interface MontagemCriador {
  destrave: EstadoDestrave
  resultado: ResultadoSugestao
}

async function primeiroMesComVenda(): Promise<string | null> {
  const pedidos = await banco.pedidos
    .filter((p) => p.apagado_em === null && p.status === 'fechado')
    .toArray()
  if (pedidos.length === 0) return null
  return mesDe(pedidos.map((p) => p.data).sort()[0])
}

// Quantos meses de historico cada base precisa ler.
//
// ⚠ Este corte e de LEITURA, nao de regra: cada mes custa varias consultas ao
// banco, e sem ele abrir a tela com tres anos de historico faria 36 rodadas de
// numerosDoMes no celular. Quem decide a janela da media continua sendo
// sugerir() -- ele corta de novo por dentro.
//
// ⚠ Os dois cortes NAO sao simetricos, medido em 2026-08-06: ler DEMAIS aqui
// nao muda numero nenhum (sugerir corta de novo) e so custa leitura; ler DE
// MENOS encolhe a media em silencio, porque sugerir nao tem como saber que
// faltou mes. Por isso este numero nunca pode ficar abaixo da janela de
// bases.ts -- e o teste 'seis_meses le os seis meses da janela, nao menos' que
// trava isso.
const MESES_A_LER: Record<Base, number> = { tres_meses: 3, seis_meses: 6, anual: 48 }

// pctDinheiro opcional: e o percentual que ela mexe NA TELA, para ver o efeito
// na hora sem ter de ir gravar a configuracao. Ausente, vale o que esta gravado.
export async function montarSugestao(
  escopo: string,
  base: Base,
  mesAlvo: string,
  hoje: Date,
  pctDinheiro?: number,
): Promise<MontagemCriador> {
  const primeiroMes = await primeiroMesComVenda()
  const destrave = destraveDaBase(base, primeiroMes, mesAlvo, hoje)
  const vazio: ResultadoSugestao = { podeSugerir: false, motivo: null, sugestoes: [] }
  if (!destrave.destravado || !primeiroMes) return { destrave, resultado: vazio }

  const config = await lerConfiguracao()
  const passos = pctDinheiro === undefined ? config : { ...config, pctDinheiro }
  // ⚠ cobertura_linhas devolve 0 no escopo pessoal (metasDados.ts:63), porque
  // "linha" e sempre linha de uma representada. Oferecer la seria sugerir uma
  // meta de 3% em cima de nada.
  const tipos: Meta['tipo'][] = config.tiposAtivos.filter(
    (t) => t !== 'cobertura_linhas' || escopo !== 'pessoal',
  )

  const fechados = mesesFechados(primeiroMes, hoje).slice(-MESES_A_LER[base])
  const historico: Record<string, NumerosDoMes> = {}
  for (const mes of fechados) {
    historico[mes] = await numerosDoMes(primeiroDiaDoMes(mes), ultimoDiaDoMes(mes), escopo)
  }

  return {
    destrave,
    resultado: sugerir({ base, historico, mesAlvo, passos, tipos }),
  }
}
